const invoicingPageContent = [
  {
    "content": "Invoicing",
    "type": "title"
  },
  {
    "content": "At the end of each billing period (eg. each month) Assuranceski automatically summarizes insurance purchases made via API (without hosted payment) in that period, creates an invoice and sends it to you along with a link to a Payplug payment gate to enable instant invoice payment.\n\nInvoice recipients will be defined via a convenient data collection form during the initial set-up (before generation of the API key).",
    "type": "subtitle"
  },
  {
    "type": "separator"
  }
]

export default invoicingPageContent
